import Prefixer from 'inline-style-prefixer';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import fonts from '../../../styles/fonts';

const classRoomNotificationCellStyle = new Prefixer().prefix({
  paper: {
    height: 105,
    marginBottom: 20,
    cursor: 'pointer',
    position: 'relative',
  },
  innerContainer: {
    position: 'relative',
    padding: 30,
  },
  avatarContainer: {
    float: 'left',
    marginRight: 25,
  },
  infoContainer: {
    float: 'left',
    width: 'calc(100% - 70px)',
  },
  titleLabel: {
    fontSize: 14,
    marginBottom: 5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  timeLabel: {
    ...fonts.light,
    fontSize: 14,
    color: colors.grey6,
  },
  newBadge: {
    width: 12,
    height: 12,
    position: 'absolute',
    top: 10,
    right: 10,
    borderRadius: 6,
    backgroundColor: colors.orange,
  },
  action: {
    ...fonts.light,
  },
  instructor: {
    color: colors.pink,
  },
  instructorLabel: {
    ...fonts.light,
  },
});

export default classRoomNotificationCellStyle;
